module.exports = __webpack_public_path__ + "static/media/ss-jupyter-ml.68932e9d.png";